import { Button, Icon, Typography } from "@saviynt/design-system";
import { useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import "./PoliciesPageHeader.css";
import { usePoliciesFilter } from "../../context/PoliciesFilterContext";
import { WORKFORCE_TAB } from "../../constants/policies.constants";

export default function PoliciesPageHeader() {
  const navigate = useNavigate();
  const { filterValues } = usePoliciesFilter();
  const category =
    filterValues.selectedFilters.category[0]?.value ?? WORKFORCE_TAB;

  return (
    <>
      <div
        style={{
          borderBottomColor: "var(--color-border-secondary-subtlest, #293950)",
        }}
        className="PoliciesPageHeader flex items-center justify-between mb-6 p-6 border-b border-[#CFD9E9]"
      >
        <Typography kind="h1" desktop="h1-d" mobile="h1-d">
          <FormattedMessage
            defaultMessage="Posture Policies"
            id="g0vycG"
            description="Header title for the policies page"
          />
        </Typography>

        <Button
          kind="filled"
          leftIcon={<Icon kind="Add" />}
          onClick={() => navigate({ to: "/new-policy", search: { category } })}
        >
          <FormattedMessage
            defaultMessage="New Policy"
            id="x8p3QT"
            description="Button to create a new policy"
          />
        </Button>
      </div>
    </>
  );
}
